import Advantages from "../components/advantages/Advantages";
import Banner from "../components/banner/Banner";
import Closing from "../components/closing/Closing";
import Methods from "../components/methods/Methods";
import Promote from "../components/promote/Promote";
import SuccessFactor from "../components/successFactor/SuccessFactor";
const Home = () => {
  return (
    <>
      <Banner />
      <Advantages />
      <SuccessFactor />
      <Promote />
      <Methods />
      <Closing />
    </>
  );
};

export default Home;
